import { useEffect } from "react";
import gsap from "gsap";
import { useSceneStore } from "@/state/useSceneStore";

export const LightSwitch = (): null => {
  const mesh = useSceneStore((s) => s.objects.switch);
  const theme = useSceneStore((s) => s.theme);

  useEffect(() => {
    if (!mesh) return;
    const lever = mesh.children[0];
    if (!lever) return;
    const target = theme === "dark" ? Math.PI / 7 : 0;
    const tween = gsap.to(lever.rotation, {
      z: target,
      duration: 0.4,
      ease: "power2.out",
    });
    return () => {
      tween.kill();
    };
  }, [mesh, theme]);

  return null;
};
